import { defineComponent as _defineComponent } from 'vue'
import { dropRight, last } from "lodash";
import { computed } from "vue";
import { useRoute } from "./router";
import { useRootStore } from "./store/pinia";
import CustomDialogs from "./components/common/CustomDialogs.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useRootStore();

const theme = computed(() => process.env.VUE_APP_THEME_NAME || "gen-trader")

const layout = computed(() => {
  const route = useRoute();
  const layout = route.meta?.layout;
  if (layout === null) {
    return "div";
  }
  if (layout) {
    return layout;
  }
  if (typeof layout === "undefined" && route.name) {
    let matched = [...route.matched];
    let parentLayout = null;
    while (!parentLayout && matched.length > 0) {
      matched = dropRight(matched);
      parentLayout = last(matched)?.meta?.layout;
    }
    return parentLayout;
  }
  return route.meta?.layout;

})

return { __sfc: true,store, theme, layout, CustomDialogs }
}

})